import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "group" }
const _hoisted_3 = { class: "box welcome" }
const _hoisted_4 = { class: "box evaluations" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "box my-evaluations" }

import store from "@/store";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import { PanelTheme } from "@/common/themes";
import { svgIcon, baseSelect, baseTable } from "@/common/components";

import { evaluationListByMember } from "@/common/api/rest/evaluation";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();

const monthOptions = [];

const accountId = computed(() => route.params.id as string);
const memberId = computed(() => store.getters.user?.member_id as string);

const tableHeader = computed(() => [
  { key: "code", label: "Código" },
  { key: "company", label: "Empresa" },
  { key: "date", label: "Data" },
]);

const tableData = ref([]);

// function fecthData() {
//   evaluationListByMember(accountId.value, memberId.value).then((response) => {
//     console.log(response);
//   });
// }

// onMounted(() => {
//   fecthData();
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelTheme), null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("span", null, " Bem vindo ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_unref(store).getters.profile?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "AVALIAÇÕES", -1)),
              _createVNode(_unref(baseSelect), { options: [] })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(svgIcon), {
                icon: "time-b",
                size: "2rem"
              }),
              _cache[2] || (_cache[2] = _createTextVNode(" 0h 0m ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header" }, [
            _createElementVNode("div", { class: "title" }, "MINHAS AVALIAÇÕES")
          ], -1)),
          _createVNode(_unref(baseTable), {
            header: tableHeader.value,
            data: tableData.value,
            options: true,
            view: true,
            paginated: false,
            "show-search": false,
            add: false
          }, null, 8, ["header", "data"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})